import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Button,
  Paper,
  Stack,
  useTheme,
  useMediaQuery,
  Grid,
} from "@mui/material";
import {
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  Save as SaveIcon,
} from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { useFirebaseAuth } from "../../hooks/useFirebaseAuth";
import { Loading } from "../../components/Loading";
import BookingDetails from "./BookingDetails";
import IncomeDetails from "./IncomeDetails";
import AddBookingExpense from "./AddBookingExpense";
import NavigationHeader from "../../components/NavigationHeader";

const steps = [
  {
    id: "booking",
    label: "Rental Details",
    description: "Party information and trip details",
  },
  {
    id: "income",
    label: "Income Details",
    description: "Revenue and payment information",
  },
  {
    id: "expense",
    label: "Expense Details",
    description: "Costs and expense tracking",
  },
];

const NewBooking: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { user, loading: authLoading } = useFirebaseAuth();
  const { id } = useParams();
  // Step management
  const [activeStep, setActiveStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [incomeSummary, setIncomeSummary] = useState<any>({
    amountBeforeGst: 0,
    totalGstAmount: 0,
    gstPercentage: 0,
    amountAfterGst: 0,
    overLimitKms: 0,
    incomeType: "perkm",
  });

  const [rentalJourneyId, setRentalJourneyId] = useState<string>("");
  const [vehicle, setVehicle] = useState<any>({
    vehicleId: "",
    vehicleNumber: "",
    vehicleType: "",
  });

  // Validation for each step
  const validateStep = (step: number): boolean => {
    switch (step) {
      case 0: // Booking Details
        return true;
      case 1: // Income Details
        // Will implement validation when income step is ready
        return true;
      case 2: // Expense Details
        // Will implement validation when expense step is ready
        return true;
      default:
        return false;
    }
  };

  const handleNext = () => {
    if (validateStep(activeStep)) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleStepClick = (step: number) => {
    // Allow navigation to previous steps or current step
    if (step <= activeStep) {
      setActiveStep(step);
    }
  };

  const handleSave = async () => {
    if (!validateStep(activeStep)) {
      return;
    }

    setIsLoading(true);

    try {
      // Navigate back to bookings list
      navigate("/rental", {
        state: {
          message: "Rental created successfully",
          type: "success",
        },
      });
    } catch (error) {
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  // const renderStepContent = () => {
  //   switch (activeStep) {
  //     case 0:
  //       return (
  //         <BookingDetails
  //           // data={bookingData}
  //           // onChange={setBookingData}
  //           activeStep={activeStep}
  //           setActiveStep={setActiveStep}
  //           handleBack={handleBack}
  //           handleNext={handleNext}
  //           handleSave={handleSave}
  //           // isLoading={isLoading}
  //           steps={steps}
  //           setRentalJourneyId={setRentalJourneyId}
  //           setVehicle={setVehicle}
  //         />
  //       );
  //     case 1:
  //       return (
  //         <IncomeDetails
  //           // data={incomeData}
  //           incomeSummary={incomeSummary}
  //           setIncomeSummary={setIncomeSummary}
  //           activeStep={activeStep}
  //           handleBack={handleBack}
  //           isLoading={isLoading}
  //           steps={steps}
  //           setActiveStep={setActiveStep}
  //           rentalJourneyId={rentalJourneyId}
  //           from="create"
  //         />
  //       );
  //     case 2:
  //       return (
  //         <AddBookingExpense
  //           // vehicleNumber={bookingData.vehicleNumber}
  //           activeStep={activeStep}
  //           handleBack={handleBack}
  //           handleNext={handleNext}
  //           handleSave={handleSave}
  //           steps={steps}
  //           rentalJourneyId={rentalJourneyId}
  //           vehicle={vehicle}
  //         />
  //       );
  //     default:
  //       return null;
  //   }
  // };

  if (authLoading) {
    return <Loading message="Loading..." fullScreen={true} />;
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 3, mb: 6 }}>
      <NavigationHeader
        title={
          id === "schedule" ? "Schedule New Booking" : "Create New Booking"
        }
        breadcrumbs={[
          { label: "Booking", path: "/rental" },
          { label: "New Booking" },
        ]}
      />

      {/* Stepper */}
      {/* <Paper
        elevation={2}
        sx={{
          p: 1,
          mb: 1,
          borderRadius: 2,
        }}
      >
        <Stepper
          activeStep={activeStep}
          orientation={isMobile ? "vertical" : "horizontal"}
          sx={{
            "& .MuiStepLabel-label": {
              fontSize: "0.75rem",
              fontWeight: 500,
            },
            "& .MuiStepLabel-label.Mui-active": {
              fontWeight: 600,
            },
          }}
        >
          {steps
            .filter((step) => {
              if (id === "schedule" && step.id === "expense") {
                return false;
              }
              return true;
            })
            .map((step, index) => (
              <Step
                key={step.id}
                sx={{
                  cursor: index <= activeStep ? "pointer" : "default",
                  "& .MuiStepLabel-root": {
                    cursor: index <= activeStep ? "pointer" : "default",
                  },
                }}
                onClick={() => handleStepClick(index)}
              >
                <StepLabel
                  optional={
                    !isMobile && (
                      <Typography
                        variant="caption"
                        sx={{
                          color: "text.secondary",
                          fontSize: "0.55rem",
                        }}
                      >
                        {step.description}
                      </Typography>
                    )
                  }
                >
                  {step.label}
                </StepLabel>
              </Step>
            ))}
        </Stepper>
      </Paper> */}

      {/* Step Content */}
      {/* {renderStepContent()} */}
      <BookingDetails
        // data={bookingData}
        // onChange={setBookingData}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        handleBack={handleBack}
        handleNext={handleNext}
        handleSave={handleSave}
        // isLoading={isLoading}
        steps={steps}
        setRentalJourneyId={setRentalJourneyId}
        setVehicle={setVehicle}
      />
    </Container>
  );
};

export default NewBooking;
